import { createFeatureSelector } from '@ngrx/store';

import { HistoryModuleState } from '../models/history.model';

export const selectHistory = createFeatureSelector<HistoryModuleState>('historyModule');
